"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("./http.service");
var find_http_error_1 = require("../error/find-http-error");
var JiraIssueInfoService = /** @class */ (function () {
    function JiraIssueInfoService(httpService) {
        this.httpService = httpService;
        this.TEST_RESULT_END_POINT = '/jira/test-results';
        this.ISSUE_TYPE_END_POINT = '/jira/issue-types';
        this.STORAGE_STATUS_END_POINT = '/jira/storage-status';
        this.RESCHEDULE_REASONS_END_POINT = '/jira/reschedule-reasons';
        this.FAILURE_CATEGORY_END_POINT = '/jira/failure-category';
        this.FAILURE_CAUSE_BY_CATEGORY_END_POINT = '/jira/failure-cause-by-category';
        this._httpService = httpService;
    }
    JiraIssueInfoService.prototype.getTestResults = function () {
        return this._httpService.get(this.TEST_RESULT_END_POINT + "/", Array, find_http_error_1.FindHttpError);
    };
    JiraIssueInfoService.prototype.getIssueTypes = function () {
        return this._httpService.get(this.ISSUE_TYPE_END_POINT + "/", Array, find_http_error_1.FindHttpError);
    };
    JiraIssueInfoService.prototype.getStorageStatus = function () {
        return this._httpService.get(this.STORAGE_STATUS_END_POINT + "/", Array, find_http_error_1.FindHttpError);
    };
    JiraIssueInfoService.prototype.getRescheduleReasons = function () {
        return this._httpService.get(this.RESCHEDULE_REASONS_END_POINT + "/", Array, find_http_error_1.FindHttpError);
    };
    JiraIssueInfoService.prototype.getFailureCategory = function () {
        return this._httpService.get(this.FAILURE_CATEGORY_END_POINT + "/", Array, find_http_error_1.FindHttpError);
    };
    JiraIssueInfoService.prototype.getFailureCauseByCategory = function (failureCategory) {
        return this._httpService.get(this.FAILURE_CAUSE_BY_CATEGORY_END_POINT + "?failureCategory=" + failureCategory, Array, find_http_error_1.FindHttpError);
    };
    JiraIssueInfoService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    return JiraIssueInfoService;
}());
exports.JiraIssueInfoService = JiraIssueInfoService;
//# sourceMappingURL=jira-info-service.js.map


// WEBPACK FOOTER //
// jira-info-service.js